import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCkwJdIktbaHH_FSIs7BPCa_IbI9ViNz84",
  authDomain: "wrwlf-app.firebaseapp.com",
  projectId: "wrwlf-app",
  storageBucket: "wrwlf-app.appspot.com",
  messagingSenderId: "363910986071",
  appId: "1:363910986071:web:0aed4544f9490522416612",
  measurementId: "G-GLG5HKFQXQ",
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
